/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.

  Modified by yang@onerockwell

==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

function rfkTrack (eventType, ...lineItems) {
    window.rfk = window.rfk || [];
    window.rfk.push(['trackEvent', {
        type: eventType,
        name: (function () {
            var pathname = window.location.pathname;

            if (eventType === 'a2c') {
                if (/^\/products/i.test(pathname)) return 'pdp';
                if (/^\/collections/i.test(pathname)) return 'qview';
                if (/^\/cart/i.test(pathname)) return 'cart';
                return 'other';
            } else return 'cart';
        })(),
        value: { products: lineItems.map(({ sku }) => ({ sku })) },
    }]);
}

function isItemGwp ({ properties_all, properties }) {
    return (properties_all && properties_all._gwp === 'true') || properties._gwp === 'true';
}

function discountItem (item) {
    Object.assign(item, {
        discounted_price: 0,
        final_line_price: 0,
        final_price: 0,
        line_price: 0,
        original_line_price: item.line_level_total_discount,
        original_price: item.total_discount,
        price: 0,
    });
}

function processCart (cart) {
    cart.items.filter(isItemGwp).forEach((item) => {
        cart.items_subtotal_price -= item.final_line_price;
        cart.sub_total -= item.final_line_price;
        cart.total_price -= item.final_line_price;

        discountItem(item);
    });
    return cart
}

function processCartItem (item) {
    if (isItemGwp(item)) {
        discountItem(item);
    }

    return item;
}

function _fetch(url, settings) {
    settings = settings || {};

    // 'same-origin' is the default after 2017
    settings.credentials = 'same-origin';

    return window.fetch(url, settings).then((res) => {
        if (res.ok) return res.json();
        else throw res;
    });
}

async function triggerError (err, callback) {
    console.error(err);

    let messages = {
        long: 'There was an error adding the item to the cart.',
        short: 'Error',
    };
    if ('max' in err) {
        // Quantity error
        messages = {
            long: 'One or multiple item(s) exceed the max ' + err.max + ' quantity allowed',
            short: 'Max Quantity',
        }
    } else {
        // Other error
        const body = await err.json();
        if (body.message === 'Cart Error') {
            messages = {
                long: 'This item is out of stock.',
                short: 'Out of Stock',
            }
        }
    }

    if ((typeof callback) === 'function') {
        callback(err, messages);
    } else {
        ShopifyAPI.onError(err, messages);
    }

    const $body = $('body');
    $body.trigger('errorAddItem.ajaxCart', [messages]);
    $body.trigger('completeAddItem.ajaxCart', err);
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    const $body = $('body');
    $body.trigger('beforeUpdateCartNote.ajaxCart', note);

    _fetch('/cart/update.js', {
        body: 'note=' + attributeToString(note),
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        method: 'post',
    })
    .catch(async (err) => {
        const text = await err.text();
        ShopifyAPI.onError(err, text);
        $body.trigger('errorUpdateCartNote.ajaxCart', [err, text]);

        console.error(new Error(text));
        return Promise.reject(err);
    })
    .then(processCart)
    .then((cart) => {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }

        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
        $body.trigger('completeUpdateCartNote.ajaxCart', note);
    })
    .catch(() => {
        $body.trigger('completeUpdateCartNote.ajaxCart', note);
    });
};

ShopifyAPI.onError = function(res, message) {
    console.error(res.statusText + '(' + res.status + '): ' + message);
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
  Yang@onerockwell Added ShopifyAPI.addMultipleItems
==============================================================================*/
ShopifyAPI.checkQty = function(qty_max, qty_add, v_id){
    return new Promise((resolve, reject) => {
        const error = {
            status: 422,
            text: async () => '',
            max: qty_max
        }

        if (isNaN(parseInt(qty_max)) || !qty_max) {
            return resolve();
        }

        const max_q = parseInt(qty_max), add_q = parseInt(qty_add);
        const cart_item_q = window.Shopify.cart.items
            .filter(({ variant_id }) => +variant_id === +v_id)
            .reduce((prev, { quantity }) => prev + quantity, 0);

        if (cart_item_q + add_q > max_q) {
            // Suppressed log for production
            console.error(
                `cannot add ${add_q} x ${v_id} to cart because ` +
                `${cart_item_q} (in cart) + ${add_q} (to add) ` +
                `would be greater than ${max_q} (max allowed)`,
            );
            error.text = 'Max quantity reached';
            return reject(error);
        }

        resolve();
    })
}

ShopifyAPI.addMultipleItems = async function(data, callback, errorCallback) {
    const $body = $('body');
    $body.trigger('beforeAddItem.ajaxCart', data);

    try {
        await Promise.all(
            data.items.map(({ id, quantity: q, maxqty: mq = 10 }) => {
                return ShopifyAPI.checkQty(mq, q, id)
            })
        );
        const res = await _fetch('/cart/add.js', {
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            method: 'post',
        });
        const cart = await processCart(res);
        window.Shopify.cart = JSON.parse(JSON.stringify(cart));
        for (var line_item of cart.items) {
            rfkTrack('a2c', line_item);
    
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                ShopifyAPI.onItemAdded(line_item);
            }
    
            $body.trigger('afterAddItem.ajaxCart', [line_item]);
        }
    
        $body.trigger('completeAddItem.ajaxCart', data);
    } catch (err) {
        triggerError(err, errorCallback);
    }
};

ShopifyAPI.addItemFromForm = async function(form, callback, errorCallback) {
    const $body = $('body');
    $body.trigger('beforeAddItem.ajaxCart', form);

    const id = form.elements.id;
    const q = form.elements.quantity;
    const mq = form.elements.maxqty;

    try {
        await ShopifyAPI.checkQty(mq.value, q.value, id.value);
        const res = await _fetch('/cart/add.js', {
            body: $(form).serialize(),
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            method: 'post'
        });

        const lineItem = await processCartItem(res);
        rfkTrack('a2c', lineItem);
        if ((typeof callback) === 'function') {
            callback(lineItem, form);
        } else {
            ShopifyAPI.onItemAdded(lineItem, form);
        }

        $body.trigger('afterAddItem.ajaxCart', [lineItem, form]);
        $body.trigger('completeAddItem.ajaxCart', form);
    } catch (err) {
        triggerError(err, errorCallback);
    }
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    const $body = $('body');
    $body.trigger('beforeGetCart.ajaxCart');

    _fetch('/cart.js')
    .catch(async (err) => {
        const text = await err.text();
        ShopifyAPI.onError(err, text);

        $body.trigger('errorGetCart.ajaxCart', [err, text]);

        console.error(new Error(text));
        return Promise.reject(err);
    })
    .then(processCart)
    .then(async (cart) => {
        const gwpItem = cart.items.find(({ product_id, variant_id, properties_all, properties }) => {
            return (properties_all && properties_all._gwp === 'true') || properties._gwp === 'true';
        });

        const eligibleItems = "bags"
            ? await Promise.all(cart.items.map(({ handle }) =>
                _fetch(`/products/${handle}?view=collections.json`)
            )).then((collections) => cart.items.filter((_, i) =>
                collections[i].includes("bags"),
            ))
            : cart.items;
        const isEligible = (() => {
            const currentValue = eligibleItems.reduce((prev, curr) => prev + curr.final_line_price, 0);
            return +currentValue >= +1000;
        })();
        const endDate = (() => {
            const endDate = new Date("2021-04-11T03:00:00-0400");
            if (isNaN(endDate)) return new Date(new Date().setFullYear(new Date().getFullYear() + 1));
            else return endDate;
        })();

        if (gwpItem && (!isEligible || endDate <= new Date())) {
            await _fetch('/cart/change.js', {
                body: JSON.stringify({
                    id: gwpItem.key,
                    quantity: 0,
                }),
                headers: { 'content-type': 'application/json' },
                method: 'post',
            });

            if (window.location.pathname === '/cart') {
                window.location.reload();
            }

            cart.items.splice(cart.items.indexOf(gwpItem), 1);
        }

        window.Shopify.cart = JSON.parse(JSON.stringify(cart));

        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }

        $body.trigger('afterGetCart.ajaxCart', cart);
        $body.trigger('completeGetCart.ajaxCart');

        rfkTrack('status', ...cart.items);
    })
    .catch((err) => {
        $body.trigger('completeGetCart.ajaxCart');
        throw err;
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = async function(
    data,
    { currentQty = data.quantity - 1, variantId, maxqty = 10 },
    callback,
    errorCallback
) {
    const $body = $('body');
    $body.trigger('beforeChangeItem.ajaxCart', [data.id || data.line, data.quantity]);

    try {
        await ShopifyAPI.checkQty(maxqty, data.quantity - currentQty, variantId);
        const res = await _fetch('/cart/change.js', {
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            method: 'post',
        });
        const cart = await processCart(res);
        window.Shopify.cart = JSON.parse(JSON.stringify(cart));

        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }

        $body.trigger('afterChangeItem.ajaxCart', [data.id || data.line, data.quantity, cart]);
        $body.trigger('completeChangeItem.ajaxCart', [data.id || data.line, data.quantity]);
    } catch (err) {
        triggerError(err, errorCallback);
    }
};

/*============================================================================
  Product Options
==============================================================================*/
ShopifyAPI.selectCallback = function(variant, { domIdPrefix, product }, { initialLoad }) {
    const selected = (variant && !initialLoad);

    const $container = $(
        domIdPrefix.includes('-')
            ? `#AddToCart-${domIdPrefix.split('-').pop()}`
            : '#AddToCart'
    ).closest('.product-detail-container');

    // misc updates to dom
    if (selected) {
        const formatMoney = cents => ORW.formatMoney(Shopify.formatMoney(cents));

        // update price
        $container.find('.product-price').text(formatMoney(variant.price));

        // update compare at price and show/hide as necessary
        $container.find('.product-compare-price').text(
            formatMoney(variant.compare_at_price)
        )[variant.compare_at_price > variant.price ? 'show' : 'hide']();

        // show and update sku, upc, wishlist variant id
        $container.find('.sku').show().text(variant.sku);
        $container.find('.upc').show().text(variant.barcode);
        $container.find('#smartwishlist').show().attr('data-variant', variant.id);

        // update customizer link url
        (() => {
            const $customizerLink = $container
                .find('a[href^="/pages/"]');
            const href = ($customizerLink.attr('href') || '')
                .replace(/v\[id\]=\d+/, `v[id]=${variant.id}`);

            $customizerLink
                .attr('href', href)
                .closest('.product-feature').css('display', '');
        })();
    } else {
        // hide wishlist variant id
        $container.find('#smartwishlist').hide();

        // hide customizer link block
        $container
            .find('a[href^="/pages/"]')
            .closest('.product-feature').css('display', 'none');
    }

    // update add to bag cta copy/disabled status

    const $cta = $container.find('.add-to-cart-btn');
    const $copy = $cta.children('.add-to-cart-text');
    // const maxQty = product.tags.find(tag => tag.startsWith('qtymax:'))?.split(':')[1];

    // a variant is selected and available
    if (selected && variant && variant.available) {
        if ($cta.is('.preview')) {
            $cta.addClass('disabled').prop('disabled', true);
            $copy.text($cta.data('preview'));
        } else {
            $cta.removeClass('disabled').prop('disabled', false);
            if ($cta.is('.pre-order')) {
                $copy.text(`Pre Order`);
            } else if ($cta.closest('.list-kits').length) {
                $copy.text(`Add to Kit`);
            } else if ($cta.closest('.list-sets').length) {
                $copy.text(`Add to Set`);
            } else {
                $copy.text(`Add to Bag`);
            }
        }
    }

    // either a variant is not selected or selected variant is not available
    else {
        $cta.addClass('disabled').prop('disabled', true);

        // selected variant is not available
        if (selected) {
            if ($cta.is('.preview')) {
                $copy.text($cta.data('preview'));
            } else {
                $copy.text(`Sold Out`);
            }
        }

        // a variant is not selected
        else {
            if (
                $cta.closest('.e-gift-card').length ||
                $cta.closest('.physical-gift-card').length
            ) {$copy.text(`Select Amount`);
            } else if ($cta.is('.preview')) {
                $copy.text($cta.data('preview'));
            } else if (!product.available) {
                $copy.text(`Sold Out`);
            } else {
                $copy.text(`Select Size`);
            }
        }
    }
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function(options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $body = $('body');
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length && !$body.hasClass('template-suffix-kit')) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function() {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function(cart) {
        if ($cartCountSelector) {
            $cartCountSelector.parent().attr('data-count', cart.item_count);
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(ORW.formatMoney(Shopify.formatMoney(cart.total_price, settings.moneyFormat)));
        }
    };

    formOverride = function() {
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            var proceed = true;
            var $currForm = $(evt.target);
            var $selects = $currForm.find('select');
            $.each($selects, function(i, v) {
                if ($(v).val() == '') {
                    proceed = false;
                    return false;
                }
            });

            if (!proceed) {
                alert('Please select all options');
                return false;
            }

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            $('.cart-error').text('');

            ShopifyAPI.addItemFromForm(evt.target, null, itemErrorCallback);
        });
    };

    ShopifyAPI.onItemAdded = function(line_item) {
        $addToCart.removeClass('is-adding').addClass('is-added');
        ShopifyAPI.getCart(function(cart) {
            cartUpdateCallback(cart);
            $body.trigger('afterAddToCart.ajaxCart', cart);
        });
    };

    itemErrorCallback = function(res, messages) {
        $addToCart.removeClass('is-adding is-added');

        if (!!messages) {
            if (res.status !== 200) {
                const $error = $formContainer.find('.cart-error');
                if ($error.length) {
                    $formContainer.find('.cart-error').text(messages.long);
                } else {
                    $(`<div class="cart-error">${messages.long}</div>`).insertBefore($addToCart);
                }
            }
        }
    };

    cartUpdateCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
    };

    buildCart = function(cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p class="ajaxcart__empty">' + "Your bag is currently empty." + '</p>');
            cartCallback(cart);
            return;
        }

        // Helper to check cart item property
        Handlebars.registerHelper('ifHidden', function(a, opts) {
            if (/_\w+/.test(a)) {
                return opts.fn(this);
            } else {
                return opts.inverse(this);
            }
        });

        // Helper adds ifEqual functionality
        Handlebars.registerHelper('ifEqual', function(arg1, arg2, options) {
            return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
        });

        // Helper adds ifNotEqual functionality
        Handlebars.registerHelper('ifNotEqual', function (a, b, options) {
            if (a != b) { return options.fn(this); }
            return options.inverse(this);
        });

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

        // Add each item to our handlebars.js data
        $.each(cart.items, function(index, cartItem) {
            /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
             */
            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            const properties = cartItem.properties_all || cartItem.properties;

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                // Shopify uses a 1+ index in the API
                line: index + 1,
                url: cartItem.url,
                img: properties._image || prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: ORW.formatMoney(Shopify.formatMoney(cartItem.price, settings.moneyFormat)),
                vendor: cartItem.vendor,
                linePrice: ORW.formatMoney(Shopify.formatMoney(cartItem.line_price, settings.moneyFormat)).replace('$0.00', 'FREE'),
                originalLinePrice: ORW.formatMoney(Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat)),
                discounts: cartItem.discounts,
                discountsApplied: cartItem.line_price !== cartItem.original_line_price,
                isGiftCard: cartItem.gift_card,
                variantId: cartItem.variant_id,
            };

            items.push(item);
        });

        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalPrice: ORW.formatMoney(Shopify.formatMoney(cart.total_price, settings.moneyFormat)),
            itemCount: cart.item_count,
            itemTitle: cart.item_count > 1 ? 'items' : 'item',
            totalCartDiscount: cart.total_discount === 0 ? 0 : "\u003cp\u003eYou're saving\u003c\/p\u003e".replace('[savings]', ORW.formatMoney(Shopify.formatMoney(cart.total_discount, settings.moneyFormat))),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true
        }

        $cartContainer.append(template(data));

        cartCallback(cart);
    };

    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
    };

    adjustCart = function() {
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, '')),
                maxQty = parseInt($qtySelector.attr('max'));

            var qty = validateQty(qty, maxQty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        $body.on('click', '.ajaxcart__qty-remove', function(e) {
            e.preventDefault();
            var $el = $(this),
                line = $el.data('line'),
                variantId = $el.data('variant-id');

            if (isUpdating) {
                return;
            }
            updateQuantity(line, 0, null, variantId);
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, '')),
                maxQty = parseInt($el.attr('max')),
                variantId = $el.data('variant-id');

            var qty = validateQty(qty, maxQty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty, maxQty, variantId);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function() {
            var $el = $(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, quantity, maxqty, variantId) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (quantity === 0) {
                $row.parent().addClass('is-removed');
            }

            // Slight delay to make sure removed animation is done
            setTimeout(function() {
                ShopifyAPI.changeItem({ line, quantity }, { maxqty, variantId }, adjustCartCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };

    adjustCartCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function() {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input.enable-qty-selector');

        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id'),
                    maxQty = $el.attr('max');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId,
                        maxQty: maxQty,
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Remove previous event listerners if there is any
            $('.js-qty__adjust').off('click');
            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, '')),
                    maxQty = parseInt($qtySelector.attr('max'));

                var qty = validateQty(qty, maxQty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty < 1) qty = 1;
                }

                // make sure the requested qty is no greater than the max
                var qty = validateQty(qty, maxQty);

                // Update the input's number
                $qtySelector.val(qty).trigger('change');
            });

            // Remove previous event listerners if there is any
            $('.js-qty__num').off('change')
            // Setup listeners to validate the input
            $('.js-qty__num').on('change', function (e) {
                var $el = $(this),
                    qty = parseInt($el.val().replace(/\D/g, '')),
                    maxQty = parseInt($el.attr('max'));

                // make sure the requested qty is no greater than the max
                var qty = validateQty(qty, maxQty);

                // Update the input's number
                $el.val(qty);

                console.log($el, qty, maxQty);

                // if max qty reached, disable + and add messaging
                // else enable and show messaging
                $el.siblings('.js-qty__adjust--plus').prop('disabled', qty === maxQty);
                $el.closest('.product-quantity')
                    .find('.max-qty-msg')[qty === maxQty ? 'show' : 'hide']();
            });

            $('.js-qty__num').trigger('change');
        }
    };

    validateQty = function(qty, maxQty) {
        if ((parseFloat(maxQty) == parseInt(maxQty)) && !isNaN(maxQty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to Infinity.
            maxQty = Infinity;
        }

        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }

        return Math.min(qty, maxQty);
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));
